import { NON_WHITESPACE } from '../../../utils';
import { DISALLOWED_CHARACTERS_PATTERN } from './constants';

var validateAddress = function validateAddress(value) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var {
    props: {
      required
    } = {}
  } = metadata;
  var isPresent = Boolean(value.length) && NON_WHITESPACE.test(value);
  var result = {
    patternMismatch: DISALLOWED_CHARACTERS_PATTERN.test(value),
    valueMissing: !required ? false : !isPresent
  };
  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = !result.errors.length;
  return result;
};

export { validateAddress };